import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { EnvironmentService } from "src/app/cloud-subscription/services/environment.service";
import { CloudVendorType } from "src/app/paid-subscription/types/cloud-vendor.type";
import { ConfigureSingleEnvironment } from "src/app/types/environment.type";
import { ConnectionType } from "src/app/types/vm.type";


@Injectable()
export class ConnectionPersistenceService {

  private _environment: ConfigureSingleEnvironment
  private _connectionType: ConnectionType | undefined
  private _cloudSubscriptionId: string | undefined
  private _cloudVendor: CloudVendorType | undefined
  private _environmentName: string | undefined
  private _environmentId: number | undefined
  private _nCacheVersion: string | undefined
  private _azVnetCustomerTenantId: string | undefined
  private _azVnetCustomerGuestEmail: string | undefined
  private _vnetResourceId: string | undefined
  private _azCustomerVnetResourceId: string | undefined
  private _azVnetGuestUserId: string | undefined
  private _cloudRegion: string | undefined
  private _cloudRegionDisplayName: string | undefined
  private _serverPlan: string | undefined
  private _networkCidr: string | undefined
  private _awsVnetConnectionId: number | undefined
  private _awsVnetPeeringId: string | undefined
  private _azVnetPeeringId: string | undefined
  private _customerAwsVpcId: string | undefined
  private _customerAwsVpcCidr: string | undefined
  private _customerAzVnetCidr: string | undefined
  private _azVnetConnectionId: number | undefined
  private _azVnetCustomerResourceGroupName: string | undefined
  private _azVnetCustomerSubscriptionId: string | undefined
  private _azVnetCustomerCidrBlock: string | undefined
  private _awsVpcAccepterRouteTableId: string | undefined
  private _awsVpcAccepterOwnerId: string | undefined

  // Azure Links
  private _azLinkFindTenantId: string | undefined;
  private _azLinkAppRegistration: string | undefined;
  private _azLinkAddGuestUser: string | undefined;
  private _azLinkRbac: string | undefined;
  private _azLinkNetworkingRoles: string | undefined;
  private _azLinkFindSubscriptionId: string | undefined;
  private _azLinkResourceGroup: string | undefined;
  private _azLinkVirtualNetwork: string | undefined;
  private _azLinkCreatePeeringDifferentTenants: string | undefined;

  // AWS Links
  private _awsLinkVPC: string | undefined;
  private _awsLinkVpcPeering: string | undefined;
  private _awsLinkAcceptPeering: string | undefined;
  private _awsLinkAddRouteEntry: string | undefined;
  private _azureVnetPeeringLink: string | undefined;

  get cloudSubscriptionId(): string | undefined {
    return this._cloudSubscriptionId
  }

  get cloudVendor(): CloudVendorType | undefined {
    return this._cloudVendor
  }

  get environmentName(): string | undefined {
    return this._environmentName
  }

  get environmentId(): number | undefined {
    return this._environmentId
  }

  get connectionType(): ConnectionType | undefined {
    return this._connectionType
  }

  get vnetResourceId(): string | undefined {
    return this._vnetResourceId
  }

  get azVnetGuestUserId(): string | undefined {
    return this._azVnetGuestUserId
  }

  get azVnetCustomerTenantId(): string | undefined {
    return this._azVnetCustomerTenantId
  }

  get azVnetCustomerGuestEmail(): string | undefined {
    return this._azVnetCustomerGuestEmail
  }

  get azCustomerVnetResourceId(): string | undefined {
    return this._azCustomerVnetResourceId
  }

  get nCacheVersion(): string | undefined {
    return this._nCacheVersion
  }

  get cloudRegion(): string | undefined {
    return this._cloudRegion
  }

  get cloudRegionDisplayName(): string | undefined {
    return this._cloudRegionDisplayName
  }

  get serverPlan(): string | undefined {
    return this._serverPlan
  }

  get networkCidr(): string | undefined {
    return this._networkCidr
  }

  get awsVnetConnectionId(): number | undefined {
    return this._awsVnetConnectionId
  }

  get awsVnetPeeringId(): string | undefined {
    return this._awsVnetPeeringId
  }

  get azVnetPeeringId(): string | undefined {
    return this._azVnetPeeringId
  }

  get customerAwsVpcId(): string | undefined {
    return this._customerAwsVpcId
  }

  get customerAwsVpcCidr(): string | undefined {
    return this._customerAwsVpcCidr
  }

  get customerAzVnetCidr(): string | undefined {
    return this._customerAzVnetCidr
  }

  get azVnetConnectionId(): number | undefined {
    return this._azVnetConnectionId
  }

  get azVnetCustomerResourceGroupName(): string | undefined {
    return this._azVnetCustomerResourceGroupName
  }

  get azVnetCustomerSubscriptionId(): string | undefined {
    return this._azVnetCustomerSubscriptionId
  }

  get azVnetCustomerCidrBlock(): string | undefined {
    return this._azVnetCustomerCidrBlock
  }

  get environment(): ConfigureSingleEnvironment | undefined {
    return this._environment
  }

  get azLinkFindTenantId(): string | undefined {
    return this._azLinkFindTenantId;
  }

  get azLinkAppRegistration(): string | undefined {
    return this._azLinkAppRegistration;
  }

  get azLinkAddGuestUser(): string | undefined {
    return this._azLinkAddGuestUser;
  }

  get azLinkRbac(): string | undefined {
    return this._azLinkRbac;
  }

  get azLinkNetworkingRoles(): string | undefined {
    return this._azLinkNetworkingRoles;
  }

  get azLinkFindSubscriptionId(): string | undefined {
    return this._azLinkFindSubscriptionId;
  }

  get azLinkResourceGroup(): string | undefined {
    return this._azLinkResourceGroup;
  }

  get azLinkVirtualNetwork(): string | undefined {
    return this._azLinkVirtualNetwork;
  }

  get azLinkCreatePeeringDifferentTenants(): string | undefined {
    return this._azLinkCreatePeeringDifferentTenants;
  }

  get awsVpcAccepterRouteTableId(): string | undefined {
    return this._awsVpcAccepterRouteTableId;
  }

  get awsVpcAccepterOwnerId(): string | undefined {
    return this._awsVpcAccepterOwnerId;
  }

  get awsLinkVPC(): string | undefined {
    return this._awsLinkVPC;
  }

  get awsLinkVpcPeering(): string | undefined {
    return this._awsLinkVpcPeering;
  }

  get awsLinkAcceptPeering(): string | undefined {
    return this._awsLinkAcceptPeering;
  }

  get awsLinkAddRouteEntry(): string | undefined {
    return this._awsLinkAddRouteEntry;
  }

  get azureVnetPeeringLink(): string | undefined {
    return this._azureVnetPeeringLink;
  }

  set cloudSubscriptionId(value: string | undefined) {
    this._cloudSubscriptionId = value
  }

  set cloudVendor(value: CloudVendorType | undefined) {
    this._cloudVendor = value
  }

  set environmentName(value: string | undefined) {
    this._environmentName = value
  }

  set connectionType(value: ConnectionType | undefined) {
    this._connectionType = value;
  }

  set vnetResourceId(value: string | undefined) {
    this._vnetResourceId = value
  }

  set azVnetGuestUserId(value: string | undefined) {
    this._azVnetGuestUserId = value
  }

  set azVnetCustomerTenantId(value: string | undefined) {
    this._azVnetCustomerTenantId = value
  }

  set azVnetCustomerGuestEmail(value: string | undefined) {
    this._azVnetCustomerGuestEmail = value
  }

  set azCustomerVnetResourceId(value: string | undefined) {
    this._azCustomerVnetResourceId = value
  }

  set environmentId(value: number | undefined) {
    this._environmentId = value
  }

  set nCacheVersion(value: string | undefined) {
    this._nCacheVersion = value
  }

  set cloudRegion(value: string | undefined) {
    this._cloudRegion = value
  }

  set cloudRegionDisplayName(value: string | undefined) {
    this._cloudRegionDisplayName = value
  }

  set serverPlan(value: string | undefined) {
    this._serverPlan = value
  }

  set networkCidr(value: string | undefined) {
    this._networkCidr = value
  }

  set awsVnetConnectionId(value: number | undefined) {
    this._awsVnetConnectionId = value
  }

  set awsVnetPeeringId(value: string | undefined) {
    this._awsVnetPeeringId = value
  }

  set azVnetPeeringId(value: string | undefined) {
    this._azVnetPeeringId = value
  }

  set customerAwsVpcId(value: string | undefined) {
    this._customerAwsVpcId = value
  }

  set customerAwsVpcCidr(value: string | undefined) {
    this._customerAwsVpcCidr = value
  }

  set customerAzVnetCidr(value: string | undefined) {
    this._customerAzVnetCidr = value
  }

  set azVnetConnectionId(value: number | undefined) {
    this._azVnetConnectionId = value
  }

  set azVnetCustomerResourceGroupName(value: string | undefined) {
    this._azVnetCustomerResourceGroupName = value
  }

  set azVnetCustomerSubscriptionId(value: string | undefined) {
    this._azVnetCustomerSubscriptionId = value
  }

  set azVnetCustomerCidrBlock(value: string | undefined) {
    this._azVnetCustomerCidrBlock = value
  }

  set environment(value: ConfigureSingleEnvironment | undefined) {
    this._environment = value
  }

  set azLinkFindTenantId(value: string | undefined) {
    this._azLinkFindTenantId = value;
  }

  set azLinkAppRegistration(value: string | undefined) {
    this._azLinkAppRegistration = value;
  }

  set azLinkAddGuestUser(value: string | undefined) {
    this._azLinkAddGuestUser = value;
  }

  set azLinkRbac(value: string | undefined) {
    this._azLinkRbac = value;
  }

  set azLinkNetworkingRoles(value: string | undefined) {
    this._azLinkNetworkingRoles = value;
  }

  set azLinkFindSubscriptionId(value: string | undefined) {
    this._azLinkFindSubscriptionId = value;
  }

  set azLinkResourceGroup(value: string | undefined) {
    this._azLinkResourceGroup = value;
  }

  set azLinkVirtualNetwork(value: string | undefined) {
    this._azLinkVirtualNetwork = value;
  }

  set azLinkCreatePeeringDifferentTenants(value: string | undefined) {
    this._azLinkCreatePeeringDifferentTenants = value;
  }

  set awsVpcAccepterRouteTableId(value: string | undefined) {
    this._awsVpcAccepterRouteTableId = value;
  }

  set awsVpcAccepterOwnerId(value: string | undefined) {
    this._awsVpcAccepterOwnerId = value;
  }

  set awsLinkVPC(value: string | undefined) {
    this._awsLinkVPC = value;
  }

  set awsLinkVpcPeering(value: string | undefined) {
    this._awsLinkVpcPeering = value;
  }

  set awsLinkAcceptPeering(value: string | undefined) {
    this._awsLinkAcceptPeering = value;
  }

  set awsLinkAddRouteEntry(value: string | undefined) {
    this._awsLinkAddRouteEntry = value;
  }

  set azureVnetPeeringLink(value: string | undefined) {
    this._azureVnetPeeringLink = value;
  }

  public getAllValues(): any {
    return {
      cloudSubscriptionId: this._cloudSubscriptionId,
      cloudVendor: this._cloudVendor,
      environmentName: this._environmentName,
      environmentId: this._environmentId,
      connectionType: this._connectionType,
      vnetResourceId: this._vnetResourceId,
      azVnetGuestUserId: this._azVnetGuestUserId,
      azVnetCustomerTenantId: this._azVnetCustomerTenantId,
      azVnetCustomerGuestEmail: this.azVnetCustomerGuestEmail,
      azCustomerVnetResourceId: this._azCustomerVnetResourceId,
      nCacheVersion: this._nCacheVersion,
      cloudRegion: this._cloudRegion,
      cloudRegionDisplayName: this._cloudRegionDisplayName,
      serverPlan: this._serverPlan,
      networkCidr: this._networkCidr,
      awsVnetConnectionId: this._awsVnetConnectionId,
      awsVnetPeeringId: this._awsVnetPeeringId,
      azVnetPeeringId: this._azVnetPeeringId,
      customerAwsVpcId: this._customerAwsVpcId,
      customerAwsVpcCidr: this._customerAwsVpcCidr,
      customerAzVnetCidr: this._customerAzVnetCidr,
      azVnetConnectionId: this._azVnetConnectionId,
      azVnetCustomerResourceGroupName: this._azVnetCustomerResourceGroupName,
      azVnetCustomerSubscriptionId: this._azVnetCustomerSubscriptionId,
      azVnetCustomerCidrBlock: this._azVnetCustomerCidrBlock,
      environment: this._environment,
      awsVpcAccepterRouteTableId: this._awsVpcAccepterRouteTableId,
      awsVpcAccepterOwnerId: this._awsVpcAccepterOwnerId,

      azLinkFindTenantId: this._azLinkFindTenantId,
      azLinkAppRegistration: this._azLinkAppRegistration,
      azLinkAddGuestUser: this._azLinkAddGuestUser,
      azLinkRbac: this._azLinkRbac,
      azLinkNetworkingRoles: this._azLinkNetworkingRoles,
      azLinkFindSubscriptionId: this._azLinkFindSubscriptionId,
      azLinkResourceGroup: this._azLinkResourceGroup,
      azLinkVirtualNetwork: this._azLinkVirtualNetwork,
      azLinkCreatePeeringDifferentTenants: this._azLinkCreatePeeringDifferentTenants

    }
  }

  clearState(): void {
    this._cloudSubscriptionId = undefined
    this._cloudVendor = undefined
    this._environmentName = undefined
    this._environmentId = undefined
    this._connectionType = undefined
    this._vnetResourceId = undefined
    this._azVnetGuestUserId = undefined
    this._azVnetCustomerTenantId = undefined
    this._azVnetCustomerGuestEmail = undefined
    this._azCustomerVnetResourceId = undefined
    this._nCacheVersion = undefined
    this._cloudRegion = undefined
    this._cloudRegionDisplayName = undefined
    this._serverPlan = undefined
    this._networkCidr = undefined
    this._awsVnetConnectionId = undefined
    this._awsVnetPeeringId = undefined
    this._azVnetPeeringId = undefined
    this._customerAwsVpcId = undefined
    this._customerAwsVpcCidr = undefined
    this._customerAzVnetCidr = undefined
    this._azVnetConnectionId = undefined
    this._azVnetCustomerResourceGroupName = undefined
    this._azVnetCustomerSubscriptionId = undefined
    this._azVnetCustomerCidrBlock = undefined
    this._environment = undefined
    this._awsVpcAccepterRouteTableId = undefined
    this._awsVpcAccepterOwnerId = undefined

    this._azLinkFindTenantId = undefined
    this._azLinkAppRegistration = undefined
    this._azLinkAddGuestUser = undefined
    this._azLinkRbac = undefined
    this._azLinkNetworkingRoles = undefined
    this._azLinkFindSubscriptionId = undefined
    this._azLinkResourceGroup = undefined
    this._azLinkVirtualNetwork = undefined
    this._azLinkCreatePeeringDifferentTenants = undefined
  }
}
